import Tree from './components/Tree.vue'
export default Tree
